<div class="editor" id="{{ editorID }}">
	@if (editor.view.editable && !disabled && !formDisabled()) {
		<ngx-editor-menu
			[colorPresets]="['red', 'orange', 'yellow', 'green', 'blue', 'purple']"
			[customMenuRef]="sizeMenu"
			[editor]="editor"
			[toolbar]="toolbar"
		/>
	}
	<ngx-editor
		class="d-block overflow-auto"
		[editor]="editor"
		[formControl]="contentControl"
		[placeholder]="disabled || formDisabled() ? '' : 'Type Here...'"
		[style.height]="height"
	/>
</div>

<ng-template #sizeMenu>
	<ae-ngx-editor-size-menu [editor]="editor" />
</ng-template>
